import React, { useEffect, useState } from 'react';
import Header from './header';

//fonts
import '@fontsource/open-sans';
import '@fontsource/bebas-neue';

export default (props) => {
    let {active, children} = props;
    const [width, setWindowWidth] = useState(1024); //default to desktop

    useEffect(() => {
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const updateDimensions = () => {
        const width = window.innerWidth;
        setWindowWidth(width);
    }

    const desktop = width >= 1024;
    let className = desktop ? 'layout-desktop' : 'layout-mobile';
    return (
        <div className={className}>
            <Header active={active} desktop={desktop} />
            {children}
        </div>
    );
}